module.exports = __webpack_public_path__ + "media/student_contributors/03EmmaLynch-69fd4326.png";